import { t } from '@alluzo/shared';
import type { ErrorComponentProps } from '@tanstack/react-router';
import type { ReactElement } from 'react';
import { useEffect } from 'react';

import { Button } from '~/components/ui/button';
import { captureException } from '~/instrument';

/**
 * A page that threw. The message is shown only in development, where it helps.
 * The router catches the error before React does, so it is sent to Sentry here.
 */
export function RouteError({ error, reset }: ErrorComponentProps): ReactElement {
  useEffect(() => {
    captureException(error);
  }, [error]);
  return (
    <div className="flex h-full flex-col items-center justify-center gap-3 bg-background p-6 text-center" role="alert">
      <h1 className="type-h3">{t('route.error.title')}</h1>
      <p className="max-w-[380px] text-base text-muted-foreground">{t('route.error.body')}</p>
      {__DEV__ && error instanceof Error ? (
        <pre className="max-w-[640px] overflow-auto rounded-control bg-well p-3 text-left font-mono text-sm text-foreground-subtle">
          {error.message}
        </pre>
      ) : null}
      <div className="flex gap-2">
        <Button variant="outline" onClick={reset}>
          {t('common.try_again')}
        </Button>
        <Button variant="ghost" onClick={() => window.location.reload()}>
          {t('route.error.reload')}
        </Button>
      </div>
    </div>
  );
}
